import { Button } from '@components/ui/Button'
import styles from './styles.module.scss'

const ButtonsWrapper = ({
  children,
  onUpdate
}: {
  children: React.ReactNode
  onUpdate: (step: string) => void
}) => {
  return (
    <div className={styles.returnsForm__buttonWrapper}>
      <Button
        variant="secondary"
        fullWidth="never"
        onClick={() => onUpdate('prev')}
      >
        Back
      </Button>
      {children}
    </div>
  )
}

export default ButtonsWrapper
